import { createSelector } from 'reselect';
import {
    addedCertificationStore,
    allCertificationsStore,
    allUserCertificationsStore,
    certificationsFilterStore,
    certificationsStore,
    userCertificationsStore
} from 'app/redux/slices/certifications.slice';
import { Certification, CertificationUser, UserCertifications } from 'app/redux/models/Certification.model';
import { StateWithLoading } from '../../redux.types';
import { RootState } from '../../rootReducer';

const EMPTY_STATE = { data: [], loading: false, error: null };
const EMPTY_SINGLE_STATE = { data: null, loading: false, error: null };

export function selectAllCertifications(state: RootState): StateWithLoading<Certification[]> {
    return state[certificationsStore]?.[allCertificationsStore] ?? EMPTY_STATE;
}

export function selectAddedCertification(state: RootState): StateWithLoading<CertificationUser | null> {
    return state[certificationsStore]?.[addedCertificationStore] ?? EMPTY_SINGLE_STATE;
}

export function selectUserCertifications(state: RootState): StateWithLoading<Certification[]> {
    return state[certificationsStore]?.[userCertificationsStore] ?? EMPTY_STATE;
}

export function selectAllUserCertifications(state: RootState): StateWithLoading<UserCertifications[]> {
    return state[certificationsStore]?.[allUserCertificationsStore] ?? EMPTY_STATE;
}

export function selectCertificationsFilter(state: RootState): number[] {
    return state[certificationsStore]?.[certificationsFilterStore] ?? [];
}

/**
 * Indexe les certifications par identifiant d'Oxylien pour les afficher dans la liste des Oxyliens.
 */
export const selectCertificationsByUserId = createSelector(
    [selectAllUserCertifications],
    (allUserCertifications) => new Map<number, Certification[]>(
        allUserCertifications.data.map((userCertifications) => [userCertifications.userId, userCertifications.certifications])
    )
);

/**
 * Liste dédoublonnée et triée des certifications détenues par au moins un Oxylien, pour alimenter le filtre.
 */
export const selectFilterableCertifications = createSelector(
    [selectAllUserCertifications],
    (allUserCertifications) => {
        const certificationsById = new Map<number, Certification>();
        allUserCertifications.data.forEach((userCertifications) =>
            userCertifications.certifications.forEach((certification) => certificationsById.set(certification.id, certification))
        );

        return [...certificationsById.values()].sort((first, second) => first.name.localeCompare(second.name));
    }
);
